export default "__VITE_ASSET__8289dda4__"